export default __webpack_public_path__ + "static/media/doom1-1024.30f709fd.png";